import React from 'react';
import { connect } from 'react-redux';
import ActionsPopover from '../popovers/ActionsPopover'
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { TableRow, TableCell, Tooltip, Chip, Box } from '@mui/material';
import { formatDate } from '../../utils/dateFormatter';
import { useCallback } from 'react';
import { useMemo } from 'react';

const UserGroupRow = ({userGroup, onAction, onMembersClickAction, refresh, userReducer}) => {
    const isAdmin = userReducer?.userType?.toLowerCase() === 'admin';

    const handleEditClick = useCallback(() => {
        if (onAction) {
            onAction('edit', userGroup);
        }
    }, [onAction, userGroup]);

    const handleDeleteClick = useCallback(() => {
        if (onAction) {
            onAction('delete', userGroup);
        }
    }, [onAction, userGroup]);

    const handleOpenMembersModal = useCallback(() => {
        if (onMembersClickAction) {
            onMembersClickAction(userGroup);
        }
    }, [onMembersClickAction, userGroup]);

    const userActions = useMemo(() => {
        if (!isAdmin) return [];
        return [
            { key: 'edit',       label: 'Edit' },
            { key: 'deactivate', label: (userGroup.isActive ? 'Deactivate' : 'Activate') },
            { key: 'delete',     label: 'Delete', danger: true }
        ];
    }, [isAdmin, userGroup.isActive]);

    const renderUserCount = useCallback((userCount, onClick) => {
        if (!userCount || userCount === 0) {
            return (
                <Chip
                    label="0 users"
                    size="small"
                    variant="outlined"
                    sx={{ opacity: 0.6 }}
                />
            );
        }

        return (
            <Chip
                label={`${userCount} ${userCount === 1 ? 'user' : 'users'}`}
                size="small"
                color="primary"
                variant="outlined"
                onClick={(e) => {
                    e.stopPropagation();
                    onClick();
                }}
                sx={{ cursor: 'pointer' }}
            />
        );
    }, []);

    return (
        <TableRow
            hover
            sx={{
                '&:last-child td, &:last-child th': { border: 0 },
                opacity: userGroup.isActive ? 1 : 0.6
            }}
        >
            <TableCell align="center" sx={{ width: 50 }}>
                {isAdmin && (
                    <ActionsPopover
                        entity={userGroup}
                        items={userActions}
                        onAction={onAction}
                        refresh={refresh}
                    />
                )}
            </TableCell>
            <TableCell align="center" sx={{ width: 50 }}>
                {isAdmin && (
                    <div
                        className='s-icon-circle'
                        onClick={(e) => {
                            e.stopPropagation();
                            handleEditClick();
                        }}
                    >
                        <DriveFileRenameOutlineIcon
                            id="editIcon"
                            className='edit-icon-pencil'
                        />
                    </div>
                )}
            </TableCell>
            <TableCell align="center" sx={{ width: 50 }}>
                {isAdmin && (
                    <div
                        className='s-icon-circle'
                        onClick={(e) =>{
                            e.stopPropagation();
                            handleDeleteClick();
                        }}
                    >
                        <DeleteOutlineOutlinedIcon
                            id="deleteIcon"
                            className='delete-icon-bin'
                        />
                    </div>
                )}
            </TableCell>
            <TableCell
                sx={{ maxWidth: 100, fontWeight: 500 }}
            >
                <Tooltip title={userGroup.name}>
                    <div style={{ 
                        overflow: 'hidden', 
                        textOverflow: 'ellipsis', 
                        whiteSpace: 'nowrap' 
                    }}>
                        {userGroup.name}
                    </div>
                </Tooltip>
            </TableCell>
            <TableCell sx={{ maxWidth: 200 }}>
                {userGroup.description}
            </TableCell>
            <TableCell>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {userGroup.x3Folders?.map((folder) => (
                        folder ? <Chip key={folder} label={folder} size="small" /> : null
                    ))}
                </Box>
            </TableCell>
            <TableCell>
                <Chip
                    label={userGroup.isActive ? "Active" : "Inactive"}
                    size="small"
                    color={userGroup.isActive ? "success" : "default"}
                    variant="outlined"
                />
            </TableCell>
            <TableCell sx={{ maxWidth: 150 }}>
                {renderUserCount(userGroup.userCount, () => handleOpenMembersModal(userGroup))}
            </TableCell>
            <TableCell>
                {formatDate(userGroup.audit.modifiedOn)}
            </TableCell>
        </TableRow>
    );

}

export default connect((state) => state)(UserGroupRow);